module.exports = __webpack_public_path__ + "assets/static/media/hireprivy_splash_screen_2.8a451aa2.png";